import { Link } from "react-router-dom";
import { Logo } from "@/components/common/Logo";
import { NAV, BRAND } from "@/data/content";

const legalCols = [
  {
    heading: "Platform",
    links: [
      { label: "For Creators", to: "/creators" },
      { label: "How It Works", to: "/how-it-works" },
      { label: "How Cashouts Work", to: "/cashouts" },
    ],
  },
  {
    heading: "Trust",
    links: [
      { label: "Privacy & Trust", to: "/privacy-trust" },
      { label: "Ambassador Program", to: "/ambassadors" },
      { label: "FAQ", to: "/faq" },
    ],
  },
  {
    heading: "Get Started",
    links: [
      { label: "Apply to FanFuel", to: "/apply" },
      { label: "Apply as Ambassador", to: "/apply" },
      { label: "Login", to: "/login" },
    ],
  },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="relative border-t border-white/10 bg-ff-slate/40">
    <div className="mx-auto max-w-7xl px-5 py-16 md:px-8 md:py-20">
      <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-[1.4fr_repeat(3,1fr)]">
        <div>
          <Logo />
          <p className="mt-5 max-w-sm text-sm leading-relaxed text-ff-grey">
            {BRAND.supporting}
          </p>
          <p className="mt-6 font-display text-sm font-semibold uppercase tracking-[0.2em] text-ff-ember">
            {BRAND.pillars.join(" · ")}
          </p>
        </div>

        {legalCols.map((col) => (
          <div key={col.heading}>
            <h4 className="font-mono text-xs font-semibold uppercase tracking-[0.2em] text-ff-ivory">
              {col.heading}
            </h4>
            <ul className="mt-5 space-y-3">
              {col.links.map((l) => (
                <li key={l.label}>
                  <Link
                    to={l.to}
                    className="text-sm text-ff-grey transition-colors hover:text-ff-ivory"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <div className="mt-14 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-ff-grey md:flex-row md:items-center md:justify-between">
        <p>© {new Date().getFullYear()} FanFuel. Creator infrastructure for the Caribbean.</p>
        <p className="max-w-xl leading-relaxed text-ff-grey/70">
          FanFuel does not ask for platform passwords and does not guarantee earnings or payouts.
          Money decisions require human approval.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
